module.exports = __webpack_public_path__ + "static/univoulu-480x480-c42218fb0a66feb8c7882f686fd7bd44.png";